export default __webpack_public_path__ + "static/media/work_with_employers_icon_active.f20f3092.svg";